import React, {useState, useContext, useEffect} from 'react';

import {Card, Table, Container, Alert, ProgressBar, Badge} from 'react-bootstrap';

import axios from 'axios';
import FileDownload from 'js-file-download';
import moment from 'moment';
import UserContext from './../contexts/UserContext';
import Utils from './../Utils';

const MyOrders = (props) => {
  
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({offset: 0, limit: 10, sortby: "id", sortdir: "desc"});  
  const [data ,setData] = useState([]);
  const [total ,setTotal] = useState(0);

  const {getPackage} = useContext(UserContext); 


  const fetchMyOrders = () => {

    setLoading('Fetching your orders.. please wait..');

    axios.get(Utils.apiUrl('order/list'),Utils.apiHeaders({params: {filter: filter}})).then(res => {    
      setLoading(false);
      // if(res.data.data === false){
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return; 
      // }
      setData(res.data.data);
      setTotal(res.data.total);
    }).catch(err => {
      window.alert(JSON.stringify(err)); 
    });        
  }

  useEffect(fetchMyOrders,[filter]);

  const getInvoice = (rid) => (e) => {
    setLoading('Preparing your invoice..');
    var headers = {...Utils.apiHeaders(), "responseType": "blob"};
    axios.get(Utils.apiUrl('order/invoice?id=' + rid),headers).then((res) => {      
      FileDownload(res.data,'svasu_invoice_'+rid+'.pdf');
      setLoading(false);
      //fetchMyOrders();
    });
  }

  const onSort = (ck) => (e) => {
    const tmp = {...filter};
    if(tmp.sortby===ck){
      tmp.sortdir = tmp.sortdir === 'asc' ? 'desc' : 'asc';
    }else{
      tmp.sortby=ck;
      tmp.sortdir='desc';
    }
    setFilter({...tmp});
  }
  
  const renderListing = () => {
    const cols = {
      'id': ['Sl.',true,'text-left'],
      'product': ['Product',false,'text-left'],
      'product_id': ['SCORMs Purchased',true,'text-right'],
      'created_at': ['Ordered On',true,'text-center'],
      'amount': ['Amount',true,'text-right']
    };
    return <>
    {renderPaging()}
    <Table striped>
      <tr>
        {Object.keys(cols).map(ck => <th key={ck} className={cols[ck][2]}>
          {cols[ck][1]===false && <span className="text-dark">{cols[ck][0]}</span>}
          {cols[ck][1]===true && <>
            <span className="clickable text-info" onClick={onSort(ck)}>{cols[ck][0]}</span> 
            {filter.sortby===ck && <i className={`ml-1 sort-arrow fa fa-arrow-${filter.sortdir=='asc' ? 'up' : 'down'} text-dark`} />}
          </>}
        </th>)}
        <th className="text-center">Invoice</th>
      </tr>
      {data.map((rec,idx) => {
        return <tr key={rec.id}>
          <td className="text-left">{filter.offset + idx + 1}</td>
          <td className="text-left">{rec.name}</td>
          <td className="text-right">{rec.scorm_count}</td>
          <td className="text-center">{moment(rec.created_at).format("DD MMM YYYY hh:mm a")}</td>
          <td className="text-right">{rec.currency} {rec.amount}</td>
          <td className="text-center">           
            <span className="fa fa-download clickable mx-1" title="Download Invoice" onClick={getInvoice(rec.id)} />
          </td>
        </tr>;
      })}
    </Table>
    {renderPaging()}
    </>
  }

  const renderPaging = () => {
    return <div className="text-right pager">
      {filter.offset - filter.limit >= 0 && <span className="fa fa-chevron-left mx-2 clickable" title="Previous page" onClick={() => setFilter({...filter, offset: filter.offset-filter.limit})} />}
      {filter.offset - filter.limit < 0 && <span className="fa fa-chevron-left text-disabled" />}
      {filter.offset + filter.limit < total && <span className="fa fa-chevron-right mx-2 clickable" title="Next page" onClick={() => setFilter({...filter, offset: filter.offset+filter.limit})} />}
      {filter.offset + filter.limit > total && <span className="fa fa-chevron-right text-disabled" />}
    </div>
  }

  return <Container className="orderList">
    <div className="mb-3"><span className="clickable" onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/Builder`;}}><img src={`${process.env.PUBLIC_URL}/images/back_arrow.png`} alt="Back" /> Back</span></div>

    <div className="heading mb-4">My Orders</div>

    <Card className="card-box w-100">
      <Card.Body className="p-4">        

        {loading && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert></div>}
        {!loading && total > 0 && renderListing()}
        {!loading && total === 0 && <div className="text-center p-2 m-2"><Alert variant="warning">No Records found</Alert></div>}

      </Card.Body>
    </Card>
  </Container>;
}

export default MyOrders;